import { Employee } from '../../../domain/employees/employee';
import { EmployeeList } from '../../../domain/employees/employeeList';
import { EmployeeDTO } from '../../http/dtos/employees/employeeDTO';
import { EmployeeListDTO } from '../../http/dtos/employees/employeeListDTO';

const getEmployeesListAdapter = (responseAPI: EmployeeListDTO[]): EmployeeList[] => {
    return responseAPI
        ? responseAPI.map((employee) => {
              return {
                  id: employee.id,
                  positionName: employee.positionName,
                  groupName: employee.groupName,
                  documentNumber: employee.documentNumber,
                  firstName: employee.firstName,
                  middleName: employee.middleName,
                  lastName: employee.lastName,
                  surname: employee.surname,
                  email: employee.email,
                  cellphoneNumber: employee.cellphoneNumber,
                  isActive: employee.isActive,
              };
          })
        : [];
};

const getEmployeeAdapter = (responseAPI: EmployeeDTO): Employee => {
    return {
        id: responseAPI.id,
        documentTypeName: responseAPI.documentTypeName,
        positionName: responseAPI.positionName,
        groupName: responseAPI.groupName,
        documentNumber: responseAPI.documentNumber,
        firstName: responseAPI.firstName,
        middleName: responseAPI.middleName,
        lastName: responseAPI.lastName,
        surname: responseAPI.surname,
        email: responseAPI.email,
        cellphoneNumber: responseAPI.cellphoneNumber,
        isActive: responseAPI.isActive,
        address: responseAPI.address,
        birthDate: responseAPI.birthDate,
        cityName: responseAPI.cityName,
        gender: responseAPI.gender,
        phoneNumber: responseAPI.phoneNumber,
        cityId: responseAPI.cityId,
        documentTypeId: responseAPI.documentTypeId,
        groupId: responseAPI.groupId,
        positionId: responseAPI.positionId,
        role: responseAPI.role,
        hasUser: responseAPI.hasUser,
    };
};

export const EmployeesAdapter = {
    getEmployeesListAdapter,
    getEmployeeAdapter,
};
